import React from 'react';
import './inserieren_completed.css';

export default class InserierenCompleted extends React.Component {
  render() {
    return (
      <div>
        <h2>Eintragung erfolgreich</h2>
        <p>Ihr Inserat wird aktuell vor der freischaltung geprüft. dies dauert in der Regel 1-2 Tage.</p>
      </div>
    );
  }
}